import { SezioneAggiuntivaArticolo } from "./SezioneAggiuntivaArticolo";

export class SezioneAggiuntiva {
    id!: number;
    codice?: string;
    deliverectId?: string;
    articoloPadreId?: number;
    nome?: string;
    descrizione?: string;
    /**
     * @deprecated
     */
    tipologia!: "singola" | "multipla";
    sezioneAggiuntivaArticoloList?: SezioneAggiuntivaArticolo[];
    /**
     * @deprecated
     */
    obbligatorio!: boolean;
    aziendaId?: number;
    min: number = 0;
    max: number = 0;

    static fromJson(json: any) {
        let result = new SezioneAggiuntiva();
        result.id = json.id;
        result.codice = json.codice;
        result.deliverectId = json.deliverectId;
        result.articoloPadreId = json.articoloPadreId;
        result.nome = json.nome;
        result.descrizione = json.descrizione;
        result.tipologia = json.tipologia;
        result.obbligatorio = json.obbligatorio;
        result.aziendaId = json.aziendaId;

        if (json.sezioneAggiuntivaArticoloList) {
            result.sezioneAggiuntivaArticoloList = json.sezioneAggiuntivaArticoloList.map((sezioneAggiuntivaArticolo: any) => SezioneAggiuntivaArticolo.fromJson(sezioneAggiuntivaArticolo));
        }

        result.min = json.min;
        result.max = json.max;

        return result;
    }
}
